import { fetch as fetchRaw } from '@lib/fetch';
import { backend } from '../services';
import type {
  AiProcessingStats,
  AiProcessingSummary,
  ClassifyResultsResponse,
  CompanyDocumentProcess,
} from './types/ai-processing';

const fetch = (url: string, ...args: unknown[]) =>
  fetchRaw([backend.url, url], ...args);

export function getAiProcessingStatusSummary(
  sortByStatus?: string,
): Promise<{ data: { data: AiProcessingSummary } }> {
  return fetch(
    `/ai-processing-status/summary${sortByStatus && sortByStatus !== 'ALL' ? `?sortByStatus=${sortByStatus}` : ''}`,
    {
      method: 'GET',
    },
  ) as Promise<{ data: { data: AiProcessingSummary } }>;
}

export function dismissAiProcessingItem(id: string): Promise<void> {
  return fetch(`/ai-processing-status/${id}/dismiss`, {
    method: 'PATCH',
  }) as unknown as Promise<void>;
}

export function dismissAiProcessingItemByAsset(assetId: string): Promise<void> {
  return fetch(`/ai-processing-status/asset/${assetId}/dismiss`, {
    method: 'PATCH',
  }) as unknown as Promise<void>;
}

export function getAiProcessingStats(): Promise<{
  data: { data: AiProcessingStats };
}> {
  return fetch('/ai-processing-status/stats', {
    method: 'GET',
  }) as Promise<{ data: { data: AiProcessingStats } }>;
}

export function classifyDropBoxFiles(fileIds: string[]): Promise<void> {
  return fetch('/files/drop-box/classify', {
    method: 'POST',
    body: JSON.stringify({ fileIds }),
  }) as unknown as Promise<void>;
}

export function acceptDropBoxFiles(
  files: { fileId: string; acceptedType: string }[],
): Promise<void> {
  return fetch('/files/drop-box/accept', {
    method: 'POST',
    body: JSON.stringify({ files }),
  }) as unknown as Promise<void>;
}

export function getClassifyResults(
  fileIds: string[],
): Promise<{ data: { data: ClassifyResultsResponse } }> {
  return fetch('/files/drop-box/classify/results', {
    method: 'POST',
    body: JSON.stringify({ fileIds }),
  }) as Promise<{ data: { data: ClassifyResultsResponse } }>;
}

export function getCompanyDocumentProcess(
  workflowId: string,
): Promise<{ data: { data: CompanyDocumentProcess } }> {
  return fetch(`/company-documents/process/${workflowId}`, {
    method: 'GET',
  }) as Promise<{ data: { data: CompanyDocumentProcess } }>;
}
